import React from "react";
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {GeoModalWrapperBox} from '../boxes/geo-modal-wrapper.box';
import {IModalDialogHandler} from '../../../services/dialog/dialog.service.interface';
import {CyClass} from '../../../../common/cy-classes';
import { ModalDialogActionsComponent } from "../../modal-dialog/modal-dialog-actions.component";
import { DialogTextBox, DialogHighlightedTextBox } from "../../modal-dialog/boxes/text/dialog-text.box";

interface IGeoPermissionsPopupComponentProps {
    onOkPressed: () => any;
    dialogHandler: IModalDialogHandler;
    headerText1?: string;
    headerText2?: string;
}

export class GeoPermissionsPopupComponent extends OrbitComponent<IGeoPermissionsPopupComponentProps> {

    private _onOkPressed = () => {
        this.services.analytics.sendAnalytics('Client_Message', 'GeoPermissionsPopupComponent', 'APPROVE');
        this.props.onOkPressed();
        this._closeDialogBox();
    };

    private _closeDialogBox = () => {
        this.props.dialogHandler && this.props.dialogHandler.close();
    };

    render() {

        const {headerText1,headerText2} = this.props;

        return (
            <GeoModalWrapperBox>
                {headerText1 && <DialogHighlightedTextBox>{headerText1}</DialogHighlightedTextBox>}
                {headerText2 && <DialogTextBox>{headerText2}</DialogTextBox>}
                <ModalDialogActionsComponent primaryAction={{
                    text: this.services.translation.translate("GEO_PERMISSIONS_BUTTON"),
                    onClick: this._onOkPressed,
                    className: CyClass('cy-state-select-approve-button')
                }} />
            </GeoModalWrapperBox>
        );
    }
}
